<template>
  <section
    v-if="banner_message"
    class="hero"
    :class="banner_class"
    style="position: absolute; top: 0; left: 0; right: 0; z-index: 999"
  >
    <div class="hero-body">
      <div class="container">
        <button
          class="delete is-pulled-right mt-2"
          @click="closeBanner"
        />
        <h2
          class="title is-4 flex-center"
          style="line-height: 31px"
        >
          {{ banner_message }}
        </h2>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, inject, onUnmounted, ref } from 'vue';
import INJECT_KEYS from '@/app/data/inject_keys';

const emitter = inject(INJECT_KEYS.EMITTER);

const banner_color = ref(null);
const banner_message = ref(null);

let timeout = null;

const banner_class = computed(() => `is-${banner_color.value}`);

function closeBanner() {
  banner_color.value = null;
  banner_message.value = null;
}

function showBanner({ message, color }) {
  if (timeout) {
    clearTimeout(timeout);
  }
  banner_color.value = color;
  banner_message.value = message;
  timeout = setTimeout(() => {
    closeBanner();
  }, 5000);
}

emitter.on('banner', showBanner);

onUnmounted(() => {
  emitter.off('banner', showBanner);
});
</script>
